/**
 * NO03 - Fakturakopi Page
 * Main page component for invoice copy search and display
 */

import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
import clsx from 'clsx';
import LPAppBar from '../../app/components/LPAppBar';
import LPDrawer from '../../app/components/LPDrawer';
import ShiftHome from '../../app/components/ShiftHome';
import Utils from '../../felles/Utils';
import MenuItemTarget from '../../models/MenuItemTarget';
import UISize from '../../models/UISize';
import * as actions from '../../store/actions/index';
import * as actionsNO03 from '../../store/actions/indexNO03';
import { AppState } from '../../store/rootReducer';
import { Box } from '@mui/material';
import NO03Search from './components/NO03Search';
import NO03List from './components/NO03List';
import { useStyles } from '../../assets/styles/DefaultPageStyle';

export default function NO03Page() {
    const { classes } = useStyles();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const screenSize: UISize = useSelector((state: AppState) => state.ui.screenSize);
    const open = screenSize.width > 0 && screenSize.width < 1200 ? false : true;
    const button: boolean = useSelector((state: AppState) => state.ui.isSandwichButtonTurnedOn);
    const n: MenuItemTarget = useSelector((state: AppState) => state.menuItem.menuItemTarget);
    const isResetFormEnabled: boolean = useSelector((state: AppState) => state.NO03.isResetFormEnabled);

    // Load firma list on mount
    useEffect(() => {
        dispatch(actionsNO03.NO03LoadFirmaList());
    }, [dispatch]);

    // Cleanup on unmount
    useEffect(() => {
        return () => {
            if (isResetFormEnabled) {
                dispatch(actionsNO03.NO03ResetForm(true));
            }
        };
    }, [dispatch, isResetFormEnabled]);

    // Handle keyboard shortcuts
    const handlePressedKey = (event: React.KeyboardEvent<HTMLDivElement>) => {
        const { key } = event;

        if ((event.shiftKey && key === 'F7') || key === 'F8') {
            event.preventDefault();
        }

        if ((event.shiftKey && key === 'End') || key === 'F3') {
            event.preventDefault();
            // Reset form and clear store
            dispatch(actionsNO03.NO03ClearComponentStore());

            // Navigate back to menu
            dispatch(
                actions.menuItemSetTarget(
                    new MenuItemTarget(
                        n.rootItem,
                        n.item !== '' ? n.item : n.rootItem,
                        '',
                        '',
                        n.tilpasset,
                        n.prodSynlig,
                        n.kodeSynlig,
                        n.labelSynlig,
                        n.menuSynlig,
                        n.hasChildren,
                        n.title
                    )
                )
            );
            dispatch(actions.menuItemSetSelected([n.rootItem, n.item + n.rootItem]));
            navigate(Utils.HOMEPAGE_CONTEXT + '/menu');
        }
    };

    return (
        <div className={classes.root} tabIndex={0} onKeyDown={handlePressedKey}>
            <ShiftHome />
            <CssBaseline />
            <LPDrawer />
            <main
                className={clsx(classes.content, { [classes.contentShift]: button ? true : open })}
                style={{ display: 'flex', flexDirection: 'column', overflowY: 'hidden' }}
            >
                <LPAppBar ismenuvisible={true} />
                <NO03Search />
                <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
                    <NO03List />
                </Box>
            </main>
        </div>
    );
}
